import styled, { css } from 'styled-components'

import { H5 } from '@/lib/core/components/Text'
import { Button } from '@/lib/core/components/Button'
import { Input } from '@/lib/core/components/TextField/TextField.styles'
import { Infobox } from '@/lib/core/components/Infobox'

export const AssetViewWrapper = styled.section<{ $topGap: number; $isLoading: boolean }>`
  display: flex;
  width: 100%;
  height: calc(100vh - ${({ $topGap }) => $topGap}px);
  background: #f0f1f5; /* temporary, to see map space */
  ${({ $isLoading }) =>
    $isLoading &&
    css`
      filter: blur(2px);
    `}
`
export const AssetViewHeader = styled.header`
  display: flex;
  flex: 0 0 100px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderGray};
  padding: ${({ theme }) => `${theme.layout.spacing(4)} ${theme.layout.spacing(3)}`};
`
export const AssetViewDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  background: ${({ theme }) => theme.colors.backgroundContent};
`
export const AssetViewTitle = styled(H5)`
  margin: 0 0 0 ${({ theme }) => theme.layout.spacing(2)};
  font-weight: 700;
`
export const AssetViewAvatar = styled.div`
  flex: 0 0 40px;
  margin-left: auto;
`
export const AssetViewContent = styled.div`
  overflow-y: auto;
  flex-grow: 2;
  font-size: ${({ theme }) => theme.fontSize.small};
`
export const AssetViewFormWrapper = styled.div`
  padding: ${({ theme }) => theme.layout.spacing(4)};
`
export const AssetViewFooter = styled.footer`
  display: flex;
  flex: 0 0 110px;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.layout.spacing(3)};
`
export const AssetViewActions = styled.div`
  display: flex;
  border-radius: 10px;
  padding: ${({ theme }) => `0 ${theme.layout.spacing(1)}`};
  background: ${({ theme }) => theme.colors.backgroundOpposite};
`
export const AssetViewActionButton = styled(Button)`
  padding: ${({ theme }) => theme.layout.spacing(1)};
  color: ${({ theme }) => theme.colors.backgroundContent};

  &:hover {
    color: ${({ theme }) => theme.colors.textGrayLight};
  }
`

export const AssetViewSharedBox = styled.div`
  margin-bottom: ${({ theme }) => theme.layout.spacing(3)};
  border-radius: 10px;
  padding: ${({
    theme: {
      layout: { spacing },
    },
  }) => `${spacing(2)} ${spacing(3)}`};
  background-color: ${({ theme }) => theme.colors.backgroundHighlight};

  div + & {
    margin-top: ${({ theme }) => theme.layout.spacing(3)};
  }
`

export const SharedBoxTable = styled.table`
  font-weight: 700;
`

export const LabelCell = styled.td`
  padding: ${({
    theme: {
      layout: { spacing },
    },
  }) => `${spacing(1)} ${spacing(4)} ${spacing(1)} 0`};
`

export const DataCell = styled.td`
  padding: ${({ theme }) => `${theme.layout.spacing(1)} 0`};
  word-break: break-all;
`

export const AssetViewFormTable = styled.table`
  width: 100%;

  ${Input} {
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`

export const AssetViewFormFooter = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.layout.spacing(6)};
  padding-bottom: ${({ theme }) => theme.layout.spacing(2)};

  > * {
    margin: 0 ${({ theme }) => theme.layout.spacing(1)};

    :last-of-type {
      margin-right: 0;
    }
  }
`

export const AssetViewAlert = styled.div`
  border-radius: 10px;
  padding: ${({ theme }) => theme.layout.spacing(7)};
  background: ${({ theme }) => theme.colors.backgroundError};
  font-size: ${({ theme }) => theme.fontSize.base};
`

export const AssetViewAlertHeading = styled(H5)`
  margin-top: 0;
  font-weight: 500;
  font-size: 1.125rem;
`

export const AssetViewMapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .map {
    width: 100%;
    height: 100%;
  }
`

export const LocationPausedAlert = styled(AssetViewAlert)`
  margin-bottom: ${({ theme: { layout } }) => layout.spacing(3)};
  padding: ${({ theme: { layout } }) => layout.spacing(3)};
  font-size: 1em;
`

export const LocationPausedWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.layout.spacing(2)};
  align-items: center;
  color: ${({ theme: { colors } }) => colors.textGray};
  transform: translate(-50%, -50%);
`

export const LocationPausedText = styled.p`
  width: 190px;
  max-width: 100%;
  margin: 0;
  font-weight: 600;
  font-size: ${({ theme: { fontSize } }) => fontSize.large};
  text-align: center;
`

export const FormBox = styled(Infobox)`
  align-items: flex-start;
  border: 3px solid dashed;
`
